import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import ReactSwipe from 'react-swipe';

class WelcomeView extends Component {


  render() {

    document.body.className = window.location.pathname.replace(/\//g," ")

    const swipeOptions = {
      //startSlide: 0,
      //speed: 400,
      //auto: 3000,
      continuous: true
    }

    const handleReactSwipeClick = () => {
      this.refs.reactSwipe.next();
    }

    const slideToPaneIndex0 = () => {
      this.refs.reactSwipe.slide(0,300)
    }
    const slideToPaneIndex1 = () => {
      this.refs.reactSwipe.slide(1,300)
    }
    const slideToPaneIndex2 = () => {
      this.refs.reactSwipe.slide(2,300)
    }

    // Setting up device check

    function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
          return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
        }

        if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
          return "Chrome";
        }
        
        if (/Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor)) {
          return "Safari";
        }

        return "unknown";
    }

    // With Android, Windows Phone, or iOS

    if (getMobileOperatingSystem() !== 'unknown') {
      if (this.props.current_user_id !== undefined){
        return (<Redirect to="/snap-photo" />)
      } else {
        return (
          <div className="width text-center">
            <div className="welcome">
              <img src="https://s3.amazonaws.com/public-staging.crowdfind.com/public/images/snapit/crowdfind-icon.png" alt=''/>
              <h2>Welcome to Crowdfind<br />SnapIt App</h2>
              {getMobileOperatingSystem() === 'iOS' && 
                <p className="device-alert mx-20">For an optimal experience, download the <a href="https://itunes.apple.com/us/app/crowdfind-snapit/id1087381485?mt=8">Crowdfind SnapIt</a> app from the App Store.</p>
              }
              <div className="slideshow">
                <ReactSwipe ref="reactSwipe" className="carousel" swipeOptions={swipeOptions}>
                  <div onClick={handleReactSwipeClick} style={{backgroundColor: "#fff", height: "250px"}}>
                    <h2>Manage found items with the Sanpit App from Crowdfind.</h2>
                    <p><img alt='' src="https://s3.amazonaws.com/public-staging.crowdfind.com/public/images/welcome-image3.png" width="225px" /></p>
                  </div>
                  <div onClick={handleReactSwipeClick} style={{backgroundColor: "#fff", height: "250px"}}>PANE 2</div>
                  <div onClick={handleReactSwipeClick} style={{backgroundColor: "#fff", height: "250px"}}>PANE 3</div>
                </ReactSwipe>
                <div style={{fontSize:"3em"}}>
                  <span style={{cursor: "pointer"}} onClick={slideToPaneIndex0}>1</span> &nbsp;
                  <span style={{cursor: "pointer"}} onClick={slideToPaneIndex1}>2</span> &nbsp;
                  <span style={{cursor: "pointer"}} onClick={slideToPaneIndex2}>3</span> &nbsp;
                </div>
              </div>
              <div className="buttonGroup">
                <div className="button"><Link to="/use-code">Use Code</Link></div>
                <div className="button"><Link to="/login">Login</Link></div>
              </div>
            </div>
          </div>
        )
      }

    // Without Android, Windows Phone, or iOS

    } else {
      return (
        <div className="width text-center">
          <div className="no-support mx-20">
            <img src="https://s3.amazonaws.com/public-staging.crowdfind.com/public/images/snapit/crowdfind-icon.png" alt=''/>
            <h2>Welcome to Crowdfind<br />SnapIt App</h2>
            <h2 className="no-support-title">Oops!</h2>
            <p>It looks like we can’t access your camera. Please either update your Browser or try using a different device.</p>
          </div>
        </div>
      )
    }

  }
}

WelcomeView.propTypes = {
  current_user_id: PropTypes.number
};

export default WelcomeView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/WelcomeView.js